import template from './urban-total-area.jade';
import validation from './../../../services/validation';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular
  .module('cian.addForm.urbanTotalArea', [])
  .directive('isZeroTotalArea', () => {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: (scope, element, attrs, ngModel) => {
        ngModel.$validators.zerovalue = value => {
          return value > 0;
        };
      },
    };
  })
  .directive('cianAfAboutObjectUrbanTotalArea', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      'deviceService',
      'store',
      function (deviceService, store) {
        this.isMobile = deviceService.isMobile;
        this.areaMax = 10000000;
        this.getKitchenAndLivingArea = () => {
          return (Number(this.ad.livingArea) || 0) + (Number(this.ad.kitchenArea) || 0); // значение может быть не задано, поэтому через 'или'
        };
        this.validation = validation(this.form, 'urbanTotalArea', {
          parse: 'Введите число',
          required: 'Укажите общую площадь',
          zerovalue: 'Введите корректное значение',
          min: 'Общая площадь объекта не должна быть меньше суммы площадей кухни и жилой площади',
          max: 'Допустимо не более 7 символов',
        });

        let trackedValue;

        this.handleBlur = () => {
          const value = this.ad.totalArea;

          if (value && value !== trackedValue) {
            const state = store.getState();
            const category = selectAnalyticsOfferStatus(state);

            trackRequiredFieldFill(category, 'total_area');
            trackedValue = value;
          }
        };
      },
    ],
    controllerAs: 'urbanTotalArea',
    template,
  })).name;
